import React from "react";
import { Scale } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * Reusable auth card layout used by Login / Register / 2FA / ForgotPassword.
 */
const AuthCard = ({ children, className, showLogo = true, subtitle = null }) => {
  return (
    <div
      data-testid="auth-shell"
      className="min-h-screen w-full flex items-center justify-center bg-bg-primary px-4 py-10"
      style={{
        backgroundImage:
          "radial-gradient(1200px 500px at 15% -10%, var(--color-accent-gradient-a), transparent 60%), radial-gradient(900px 400px at 105% 110%, var(--color-accent-gradient-b), transparent 60%)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
        className={cn(
          "w-full max-w-[400px] bg-bg-secondary border border-accent-pink/20 rounded-[16px] p-12 shadow-elevated",
          className
        )}
      >
        {showLogo && (
          <>
            <div className="flex items-center justify-center gap-2 mb-4">
              <Scale className="text-accent-pink" size={22} strokeWidth={2.5} />
              <span className="font-extrabold text-[18px] text-accent-pink tracking-tight">
                Judgment Enforcement AI
              </span>
            </div>
            <div className="h-px w-full bg-accent-pink/20 mb-8" />
          </>
        )}
        {subtitle}
        {children}
      </motion.div>
    </div>
  );
};

export default AuthCard;
